<template>
  <div class="form-group">
    <label v-if="label" class="control-label w-100">
      <span>{{ label }}</span>
    </label>

    <el-autocomplete
      v-model="value"
      v-validate="modelValidations.seller"
      name="seller"
      :debounce="500"
      :fetch-suggestions="querySearchAsync"
      :placeholder="placeholder + '(*)'"
      :trigger-on-focus="false"
      @select="onSelected"
    ></el-autocomplete>

    <small v-show="searchError !== ''" class="text-danger d-block">
      {{ searchError }}
    </small>

    <small v-show="seller.invalid" class="text-danger">
      {{ getError('seller') }}
    </small>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Autocomplete, Select, Option } from 'element-ui';
import remoteAutocompleteMixin from '../../mixins/remoteAutocompleteMixin';

export default {
  components: {
    [Autocomplete.name]: Autocomplete,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [remoteAutocompleteMixin],
  props: {
    label: {
      type: String,
      default: 'Seleccione Asesor',
    },

    placeholder: {
      type: String,
      default: 'Seleccione Asesor',
    },
  },

  data() {
    return {
      value: null,
      selected: null,
      sellers: [],
      modelValidations: {
        seller: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['seller']),
  },

  methods: {
    selectOptions() {
      return this.sellers;
    },

    fetchData(query) {
      this.sellers = [];
      const params = { query };

      return this.$services
        .resource('sellers')
        .search(params)
        .then((res) => res.data.data)
        .then((sellers) => {
          this.checkResults(sellers);
          this.sellers = sellers;
        });
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      return this.$validator.validateAll();
    },

    onSelected(item) {
      this.selected = item.id;
      this.$emit('input', this.selected);
    },

    clearSelection() {
      this.selected = null;
      this.value = null;
    },
  },
};
</script>

<style scoped>
.el-autocomplete {
  width: 100%;
}
</style>
